import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/homeNew.vue' // 老版本首页
import home from '../views/home.vue' // 原Launchpad页面置于首页
import Reward from '../views/reward2.vue'
import Nft from '../views/nft.vue'
import interNet from '../views/internetCafe.vue'
import gameFi from '../views/gameFi.vue'
import Protocol from '../views/Launchpad.vue'
import question from '../views/question.vue'
import software from '../views/software.vue' // 原homeNew页面置于software页面

const routes = [
  {
    path: '/',
    name: 'home',
    component: home
  },
  {
    path: '/node',
    name: 'node',
    component: Reward
  },
  {
    path: '/nft',
    name: 'nft',
    component: Nft
  },
  {
    path: '/internet',
    name: 'internet',
    component: interNet
  },
  {
    path: '/gamefi',
    name: 'gamefi',
    component: gameFi
  },
  {
    path: '/Protocol',
    name: 'Protocol',
    component: Protocol
  },
  {
    path: '/question',
    name: 'question',
    component: question
  },
  {
    path: '/software',
    name: 'software',
    component: software
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
